import gsap from "gsap";
let team = [...document.querySelectorAll(".person")];

team.forEach((t) => {
  let closeel = t.querySelector(".js-toggle");
  let unfold = t.querySelector(".person__description");
  let unfolded = false;
  gsap.set(unfold, { autoAlpha: 0, height: "0" });
  gsap.set(closeel, { rotation: 225 });
  t.addEventListener("click", (e) => {
    if (!unfolded) {
      gsap.to(unfold, {
        autoAlpha: 1,
        duration: 0.3,
        height: "auto",
        ease: "power2.out",
        onComplete: () => {
          if (window.locoScroll) window.locoScroll.update();
        },
      });
      gsap.to(closeel, { rotation: 0, ease: "power2.out" });
    } else {
      gsap.to(unfold, {
        autoAlpha: 0,
        duration: 0.3,
        height: 0,
        ease: "power2.out",
        onComplete: () => {
          if (window.locoScroll) window.locoScroll.update();
        },
      });
      gsap.to(closeel, { rotation: 225, ease: "power2.out" });
    }
    unfolded = !unfolded;
  });
});
